import React from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { Reference } from './Reference';
import { ConfirmationPaymentRefund } from './ConfirmationPaymentRefund';
import { BackToLandingPageLink } from './BackToLandingPageLink';
import { IBooking } from '../../../domain/booking/models/IBooking';
import { NewBooking } from '../../../domain/booking/models/NewBooking';
import { getShouldProceedWithoutPay } from '../../../domain/booking/models/helpers/getShouldProceedWithoutPay';
import { getOriginalGrandTotalPrice } from '../../../domain/booking/models/helpers/getOriginalGrandTotalPrice';
import { getDifference } from '../../../../shared/i18n/price/utils/getDifference';

interface IConfirmationModifiedBookingProps {
	booking: NewBooking;
	originalBooking: IBooking;
}

export const ConfirmationModifiedBooking = ({
	booking,
	originalBooking,
}: IConfirmationModifiedBookingProps) => {
	const { t } = useTranslation();
	const { reference } = booking;
	const email = booking.personalDetails?.email;

	const originalTotalPrice = getOriginalGrandTotalPrice(originalBooking);
	const shouldProceedWithoutPay = getShouldProceedWithoutPay(
		originalTotalPrice,
		booking.totalPrice,
	);
	const shouldPay = !shouldProceedWithoutPay;
	const priceDifference = getDifference(originalTotalPrice, booking.totalPrice);
	const isRefund = priceDifference.centAmount > 0;

	return (
		<>
			<Reference reference={reference} />

			{email && (
				<p>
					{t(
						isRefund
							? 'web_parking_confirmation_modified_booking_message_with_refund'
							: 'web_parking_confirmation_modified_booking_message_without_refund',
						{
							user_email_address: email,
						},
					)}
				</p>
			)}

			{(shouldPay || isRefund) && (
				<ConfirmationPaymentRefund
					booking={booking}
					originalBooking={originalBooking}
					shouldPay={shouldPay}
				/>
			)}

			<p>
				<BackToLandingPageLink />
			</p>
		</>
	);
};
